import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-21adeee8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "media-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_media_block_item = _resolveComponent("media-block-item")!

  return (_ctx.store.loaded)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref: "mediaRef",
        class: _normalizeClass(['media-wrapper', {'media-wrapper-mobile': _ctx.store.showMobile}]),
        onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setBackgroundSize && _ctx.setBackgroundSize(...args)))
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mediaArr, (item) => {
            return (_openBlock(), _createBlock(_component_media_block_item, {
              key: item.id,
              item: item,
              class: "mb-bkg-resize"
            }, null, 8, ["item"]))
          }), 128))
        ])
      ], 34))
    : _createCommentVNode("", true)
}